<template>
    <div class="recommend" :style="{backgroundImage:'url('+item.bannerUrl+')'}">
        <div class="card-list">
            <div class="userinfo">
                <div class="userinfo-l" @click="toCircleDetail(item.id)">
                    <img v-if="item.icon" :src="item.icon" />
                    <img v-else src="@/assets/default-img.png" />
                </div>
                <div class="userinfo-r">
                    <div class="username-wrap">
                        <div class="username" @click="toCircleDetail(item.id)">
                            {{item.circleName}}
                            
                            <i class=" iconfont el-icon-caret-right"></i>
                        </div>
                        <div class="enter-btn entered" v-if="item.isJoin==1" @click.stop="toUnEnter()">已加入</div>
                        <div class="enter-btn" v-else @click.stop="toEnter()">加入</div>
                    </div>
                    <div class="userinfo-tips">
                        <div class="stat-item">
	                        <span class="stat-num">{{ item.postNum || 0 }}</span>
	                        <span class="stat-label">帖子</span>
                        </div>
                        <!-- <span class="stat-line"></span> -->
                        <div class="stat-item">
	                        <span class="stat-num">{{ item.followNum || 0 }}</span>
	                        <span class="stat-label">成员</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="recommend-txt">
            {{item.content}}
        </div>
        <el-button icon="el-icon-s-data" size="mini" @click="toRank">用户榜</el-button>
	        <el-button v-if="item.productUrl" icon="el-icon-goods" size="mini" @click="toProduct" class="product-btn">产品</el-button>

        <div 
			v-if="visible"
			class="modal-mask"
			@click.self="closeModal"
			@keydown.esc="closeModal"
			tabindex="0"
		>
			<!-- 弹框主体 -->
			<div class="modal-container" :class="{ 'modal-enter': visible }">
				<!-- 关闭按钮 -->
				<img class="modal-close" @click="closeModal" src="@/assets/close.png"/>
				
				<!-- 内容区域 -->
				<div class="modal-content">
					<h2 class="modal-title">欢迎您加群圈子</h2>
					
					<div class="feature-list">
                        <div class="list-a">快来完成以下新手任务</div>
						<div 
							v-for="(item, index) in features"
							:key="index"
							class="feature-item"
							@click="handleItemClick(index)"
						>
							<span class="item-number">{{ index + 1 }}.</span>
							{{ item }}
						</div>
                        <div class="list-a ma-20">来获取更多积分吧</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
export default {
    name: 'circleRecommend',
    components: {

    },
    props: {
        item: {
            type: Object,
            value: {}
        }
    },
    data() {
        return {
            isEenter: false,
            visible: false,
            features: [
                '首次完善个人资料',
                '浏览贴子＞10s',
                '发布帖子',
                '评论帖子'
            ]
        }
    },
    created() {
        this.userId = localStorage.getItem('userId') || ''
    },
    methods: {
        async toEnter(item) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                userId: this.userId,
                circleId: this.item.id,
                circleIds: ''
            }
            ajaxParam(param)
            const res = await post('v1/circle/joinCircle', qs.stringify(param))
            if (res.data.code == 200) {
                console.log(res.data)
                this.$message.success('加入成功！')
                this.item.isJoin = 1
                this.visible = true
            } else {
                this.$message.error(res.data.msg)
            }
        },
        async toUnEnter(item) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                userId: this.userId,
                circleId: this.item.id
            }
            ajaxParam(param)
            const res = await post('v1/circle/quitCircle', qs.stringify(param))
            if (res.data.code == 200) {
                this.$message.success('退出成功！')
                this.item.isJoin = 0
            } else {
                this.$message.error(res.data.msg)
            }
        },
        toRank() {
            this.$router.push({
                path: '/circleRank?id=' + this.item.id
            })
        },
        toProduct() {
	            const url = this.item.productUrl
	            if (/^https?:\/\//i.test(url)) {
	                window.open(url, '_blank')
	            } else {
	                this.$router.push({ path: url })
	            }
	        },
	        toCircleDetail(id) {
            this.$router.push({
                path: '/circleIntroduce?id=' + this.item.id
            })
        },
        closeModal() {
            this.visible = false
            localStorage.setItem('isVisible',false)
        },
    }
}
</script>
<style scoped lang="less">
@import '../../components/aside/common.less';
.ma-20{
    margin-top: 10px;
}
.recommend {
    width: 100%;
    height: 252px;
    padding: 40px 40px 22px;
    background: url(../../assets/circle_bg.png) no-repeat 0 0;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
    margin-bottom: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    .card-list {
        color: #fff;

        .userinfo {
            .userinfo-l {
                cursor: pointer;
            }

            .userinfo-r {
                .username {
                    font-size: 18px;
                    cursor: pointer;
                    position: relative;
                    i{
                        position: absolute;
                        right:-17px;
                        top:6px;
                        font-size: 14px;
                    }
                }

                .enter-btn {
                    width: 62px;
                    height: 22px;
                    background: #FFFFFF;
                    border-radius: 14px;
                    margin-left: 25px;
                    text-align: center;
                    line-height: 22px;
                    color: #DD0515;
                    font-size: 14px;
                    overflow: hidden;
                    cursor: pointer;
                }

                .entered {
                    height: 20px;
                    border: 1px solid #fff;
                    color: #fff;
                    opacity: .7;
                    background: none;
                    line-height: 20px;
                }

                .userinfo-tips {
	                display: flex;
	                align-items: center;
	                gap: 16px;
	                margin-top: 10px;
	                .stat-item {
		                display: flex;
		                align-items: baseline;
		                gap: 4px;
	                }
	                .stat-num {
		                font-size: 20px;
		                font-weight: 700;
	                }
	                .stat-label {
		                font-size: 12px;
		                opacity: 0.7;
	                }
	                .stat-line {
		                width: 1px;
		                height: 16px;
		                background: rgba(255,255,255,0.3);
	                }
                }
            }
        }
    }

    .recommend-txt {
        color: #fff;
        opacity: .7;
        line-height: 22px;
    }

    .el-button {
        margin-top: 20px;
    }
	.product-btn {
		margin-left: 10px;
	}
}
    /* 遮罩层样式 */
    .modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		transition: opacity 0.3s ease;
	}

	/* 弹框容器 */
	.modal-container {
		position: relative;
		width: 290px;
		height: 256px;
		box-sizing: border-box;
		background: white;
		border-radius: 12px;
		padding: 30px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transform: scale(0.9);
		opacity: 0;
		transition: all 0.3s ease;
	}

	/* 入场动画 */
	.modal-enter {
		transform: scale(1);
		opacity: 1;
	}

	/* 关闭按钮 */
	.modal-close {
		position: absolute;
		top: 15px;
		right: 20px;
		width: 17px;
		height: 17px;
		cursor: pointer;
		transition: color 0.3s;
	}

	.modal-close:hover {
		color: #333;
	}

	/* 标题样式 */
	.modal-title {
		text-align: center;
		color: red;
		margin-bottom: 10px;
		font-size: 16px;
	}

	/* 功能列表 */
	.feature-list {
		list-style: none;
		padding: 0;
		margin: 0;
		color: #000;
        text-align: center;
	}
    .list-a{
        font-size: 14px;
        color: #000;
        font-weight: 600;
        margin-bottom: 17px;
    }
	.feature-item {
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s;
		display: flex;
		align-items: center;
		font-size: 13px;
		font-weight: 500;
        margin-left: 50px;
	}

	.feature-item:hover {
		background: #e9ecef;
		transform: translateX(10px);
	}

	/* 数字编号样式 */
	.item-number {
		display: inline-block;
		width: 24px;
		height: 24px;
		line-height: 24px;
		text-align: center;
		// background: #3498db;
		color: black;
		border-radius: 50%;
		font-size: 14px;
		flex-shrink: 0;
	}
</style>